import { render, staticRenderFns } from "./ShowAccountingRecord.vue?vue&type=template&id=51a6859e&scoped=true&lang=pug&"
import script from "./ShowAccountingRecord.vue?vue&type=script&lang=js&"
export * from "./ShowAccountingRecord.vue?vue&type=script&lang=js&"
import style0 from "./ShowAccountingRecord.vue?vue&type=style&index=0&id=51a6859e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6859e",
  null
  
)

component.options.__file = "ShowAccountingRecord.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {
  VCard,
})
